import { Badge, BadgeProps, ListItemIconProps } from '@mui/material'
import ListItem from '@mui/material/ListItem'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText, { ListItemTextProps } from '@mui/material/ListItemText'
import { memo } from 'react'

import LinkChild, { LinkChildProps } from '@src/lib/LinkChild'

interface SideNavListItemProps {
  'primaryText'?: ListItemTextProps['primary']
  'icon'?: React.ReactNode
  'href'?: string
  'forceActive'?: LinkChildProps['forceActive']
  'rightChild'?: React.ReactNode
  'isLegacyLink'?: boolean
  'exact'?: boolean
  'onClick'?: React.MouseEventHandler
  'data-testid'?: string
  'slotProps'?: {
    badge?: BadgeProps
    listItemIcon?: ListItemIconProps
    listItemText?: ListItemTextProps
  }
}

const SideNavListItem: React.FC<
  React.PropsWithChildren<SideNavListItemProps>
> = (props) => {
  const child = (
    <ListItem
      onClick={props.onClick}
      button
      disableRipple
      // button={true} sets the component to `a`, but the types don't reflect
      // that and complain about `href` if we don't do this. LinkChild doesn't
      // have that problem.
      component={'a'}
      href={props.href && props.isLegacyLink ? props.href : undefined}
      data-testid={props['data-testid']}
    >
      {props.icon ? (
        <ListItemIcon {...props?.slotProps?.listItemIcon}>
          {props.icon}
        </ListItemIcon>
      ) : undefined}

      <ListItemText
        {...props?.slotProps?.listItemText}
        primary={<Badge {...props.slotProps?.badge}>{props.primaryText}</Badge>}
      />

      {props.rightChild}
    </ListItem>
  )

  if (!props.href) {
    return child
  }

  return props.isLegacyLink ? (
    child
  ) : (
    <LinkChild
      to={props.href}
      activeClassName="Mui-selected"
      exact={props.exact}
      forceActive={props.forceActive}
    >
      {child}
    </LinkChild>
  )
}

export default memo(SideNavListItem)
